import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { Secured } from '@niaratech/niara-react-components/src/security/Secured';
import type { ShoppingCartState } from '@niarab2c/niarab2c-core/src/app/reducers/shoppingCart';
import type { CoreState } from '@niarab2c/niarab2c-core/src/app/reducers/core';
import { useTheme } from '../..';
import { IcHotelBuilding, IcGroup } from '../../Icons';
import * as S from './styles';
export type Mode = 'HOTEL' | 'GROUP' | 'FLIGHT';
type ClientConfig = {
  b2b_modules_forGroups_v2?: boolean;
  engineRule_enforceVersion_deleteme?: '0' | '1';
};
export type HomepageSearchTabsBarProps = {
  disableMarginBottom?: boolean;
  personId?: string;
  isClientUser?: boolean;
  person?: ShoppingCartState['person'];
  clientConfig?: ClientConfig;
  tenant?: Partial<Pick<CoreState['tenant'], 'modules_forGroups_v2' | 'distribution_disabled' | 'modules_engineRuleOptIn_deleteme'>>;
  engineRuleVersion?: '0' | '1';
};
type SearchMode = {
  mode: Mode;
  text: string;
  icon?;
  path?: string;
  permissions: string[];
  hide?: boolean;
};
const HomepageSearchTabsBar: React.FC<HomepageSearchTabsBarProps> = ({
  disableMarginBottom,
  personId,
  isClientUser,
  person,
  clientConfig,
  tenant,
  engineRuleVersion
}) => {
  const theme = useTheme();
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const [mode, setMode] = React.useState<Mode>('HOTEL');
  const modules_forGroups_v2 = tenant?.modules_forGroups_v2 && (isClientUser ? Boolean(clientConfig?.b2b_modules_forGroups_v2) : true);
  const engineRule_enforceVersion_deleteme = clientConfig?.engineRule_enforceVersion_deleteme;
  const showTab = engineRuleVersion === '1' || pathname.includes('forGroupsV2') && (tenant?.distribution_disabled ? true : !tenant?.modules_engineRuleOptIn_deleteme ? false : engineRule_enforceVersion_deleteme == '0' ? false : engineRule_enforceVersion_deleteme == '1' ? true : isClientUser ? tenant?.distribution_disabled : tenant?.modules_engineRuleOptIn_deleteme);
  const SEARCH_MODE: SearchMode[] = [{
    text: "Hotel",
    mode: 'HOTEL',
    icon: IcHotelBuilding,
    path: '/hotels4',
    permissions: ['clientConsultant', 'consultant']
  }, {
    text: "Grupo",
    mode: 'GROUP',
    icon: IcGroup,
    path: '/forGroupsV2',
    permissions: modules_forGroups_v2 ? ['clientConsultant', 'consultant'] : ['superuser']
  }
  // { text: 'i18n:Aéreo', mode: 'FLIGHT', icon: IcAeroplane, path: '/flights', permission: '' }, //não entrará agora
  ];
  const currentMode = React.useMemo(() => {
    if (pathname.includes('forGroupsV2')) return 'GROUP';
    return mode;
  }, [pathname, mode]);
  const onClick = (value: SearchMode) => {
    setMode?.(value?.mode);
    history.push(value?.path);
  };
  return showTab && modules_forGroups_v2 && <S.Container disableMarginBottom={disableMarginBottom}>
        <S.Bar borderBottom={personId && person?.id == personId}>
          {SEARCH_MODE.map(SEARCH => {
        const active = SEARCH?.mode === currentMode;
        return <Secured permissions={SEARCH.permissions}>
                <S.BarItem key={SEARCH?.mode} active={active} onClick={() => onClick(SEARCH)}>
                  <SEARCH.icon color={active ? theme.colors.primary : undefined} />
                  <S.BarText active={active}>{SEARCH?.text}</S.BarText>
                </S.BarItem>
              </Secured>;
      })}
        </S.Bar>
      </S.Container>;
};
export default HomepageSearchTabsBar;